// ts-unused-exports:disable-next-line
export type UserViewModel = {
  email: string;
  officeId: number;
  id: number;
  roles?: string[];
  permissions?: string[];
  groups: string[];
  active: boolean;
  name: string;
  firstName: string;
  lastName: string;
  office: string;
  postingGroupId: number | null;
  dormantCustomerEnabled: boolean;
  officeSettings: Record<string, string>[] | null;
};

export enum UserRole {
  Capacity = 'Capacity',
  Accounting = 'Accounting',
  Admin = 'Admin',
  Manager = 'Manager',
  CarrierRelations = 'Carrier Relations',
  CarrierRelationsAdmin = 'Carrier Relations Admin',
  Employee = 'Employee',
  Recruiter = 'Recruiter',
  Siloed = 'Outside User',
  Supervisor = 'Supervisor',
  Collections = 'Collections',
  SuperAdmin = 'Super Admin',
  AdminLite = 'Admin-Lite',
}

export type MobileOfficeDetail = {
  id: number;
  name: string;
  accountingGroupId: number | null;
  officeManager: string;
  officeManagerId: string | number;
  address1: string;
  city: string;
  state: string;
  zip: string;
};
